import classplusLogo from "../../assets/Images/classplus-logo.png";
import rightArrow from "../../assets/Images/arrow-gray.png";
import "./headings.css";
const Headings = ({
  userInputs,
  isNumberSubmitted,
  coachingName,
  showRadarScreen,
}) => {
  return (
    <div className="overflow-hidden">
      <img style={{marginLeft:"4%", marginTop: "10px"}} src={classplusLogo} alt="" className="absolute w-32 top-1 left-1" />
      <div className="flex flex-col justify-between w-full pt-16 px-2">
        {isNumberSubmitted && !showRadarScreen ? (
          <>
            <h3 className="text-2xl text-colorHeading font-semibold">
              <span className="border-b-4  border-colorWhite">Hi</span>,{" "}
              {coachingName}
            </h3>
            <p>We have something special in store for you</p>
          </>
        ) : showRadarScreen ? (
          <h3 className="text-2xl text-colorHeading font-semibold">
            These are the top 3{" "}
            {userInputs["youtuber-name"] || userInputs["online-course-name"]
              ? "content creators in your category"
              : "educators in your region"}
          </h3>
        ) : (
          <>
            <h1
              className="not-italic font-bold text-2xl headColor"
            >
              <span style={{fontSize: "20px"}}>
              Largest Free Webinar to transform ‘Teachers’ to ‘Teacherpreneurs’
                </span> <br/>
              {/* TEACHERS to TEACHER-PRENEURS */}
              {/* Teachers to Teacher-Preneurs */}
            </h1>
            <div style={{height:"230px"}} className="flex flex-row justify-between w-full lowerContainer">
              <div className="text-white mt-12 text-list">
               
<span style={{fontSize:"14px"}}>
{/* <img src={rightArrow} alt="" className="w-4 self-start" /> */}
Date: 11th September 2022 <br />
Webinar Fee: <span style={{textDecoration: "line-through"}}>₹20,000</span> FREE 
{/* REGISTER NOW  */}
<br/>
 <br/>
{/* <span>Registration Fee -  */}
<span>Register now & stand a chance to win online courses worth ₹39,000 FREE!
</span>
</span>


                {/* <p className="flex items-center mb-3.5">
                  <img src={rightArrow} alt="" className="w-4 self-start" />
                  <span className="ml-2">
                    Earn an additional monthly income of over 2 lacs.
                  </span>
                </p> */}
              </div>
              <div className="absolute bg-contain bg-no-repeat z-10 right-0 sauravDadaImg" />
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Headings;
